import router from '@/router';
import store from '@/store';

/**
 * Проверяет, является ли ошибка связанной с токеном
 * @param {Object} error - Объект ошибки
 * @returns {boolean} - true если ошибка связана с токеном
 */
export const isTokenError = (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message || '';
    

    
    const isTokenRelated = status === 401 || 
        status === 403 ||
        message.includes('token') ||
        message.includes('Token') ||
        message.includes('Access denied') ||
        message.includes('Bad token') ||
        message.includes('Invalid Token') ||
        message.includes('Expired token') ||
        message.includes('Token has expired') ||
        message.includes('Token required') ||
        message.includes('Authorization header is required') ||
        message.includes('Invalid token format') ||
        message.includes('Invalid token payload') ||
        message.includes('not granted') ||
        message.includes('Not granted') ||
        message.includes('NOT GRANTED');
    

    return isTokenRelated;
};

/**
 * Обрабатывает ошибки токена - выполняет логаут и перенаправление
 * @param {Object} error - Объект ошибки
 * @returns {boolean} - true если ошибка была обработана
 */
export const handleTokenError = (error) => {
    if (isTokenError(error)) {

        
        // Очищаем данные пользователя
        store.commit('users/logoutUser');
        
        // Перенаправляем на страницу логина только если мы не на ней уже
        if (router.currentRoute.value.name !== 'login') {

            router.push({ name: 'login' });
        }
        
        return true;
    }
    
    return false;
};

/**
 * Проверяет валидность токена в localStorage
 * @returns {boolean} - true если токен существует и пользователь залогинен
 */
export const isTokenValid = () => {
    const token = localStorage.getItem('lbToken');
    const isLogged = localStorage.getItem('lbIsLogged');
    return !!(token && isLogged === 'true');
};

/**
 * Выполняет логаут пользователя и перенаправляет на страницу логина
 */
export const forceLogout = () => {

    store.commit('users/logoutUser');
    
    if (router.currentRoute.value.name !== 'login') {
        router.push({ name: 'login' });
    }
}; 